import { useEffect, useRef, useState } from "react";
import { useToolQueue } from "../../../contexts/ToolQueueContext"
import LoadingTool from "../LoadingTool/LoadingTool";
import ParseLatex from "../ParseLatex";
import { CiUser } from "react-icons/ci";
import ReactMarkdown from 'react-markdown';
import rehypeKatex from 'rehype-katex';
import remarkMath from 'remark-math';
import 'katex/dist/katex.min.css';
import '../../../chat.module.css';
import Visalization from "../../Visualization/Visualization";
import { Altair } from "../../altair/Altair";
import { Sheet } from "../sheet/Sheet";
import remarkGfm from "remark-gfm";


export default function Conversation() {
    const { conversation, loadingTools } = useToolQueue();
    const [dialogOpen, setDialogOpen] = useState(-1);
    useEffect(() => {
        console.log(conversation);
    }, [conversation])
    const loadingConsoleRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (loadingConsoleRef.current) {
            loadingConsoleRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }, [loadingTools]);

    return (
        <div style={{
            overflowY: 'auto',
            maxHeight: '100vh'
        }} className="inner-div">
            {
                conversation.map((chat, index) => {
                    const isLastElement = index === conversation.length - 1;
                    if (chat.type == "formulas") {
                        return (
                            <div className="formula-container" key={index} ref={isLastElement ? loadingConsoleRef : null}>
                                {
                                    chat.data.split('||').map((item) => {
                                        return (
                                            <div>
                                                <ParseLatex text={item} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        )
                    }
                    else if (chat.type == "user") {
                        return (
                            <div className="formula-container" key={index} ref={isLastElement ? loadingConsoleRef : null}>
                                <div className="user-container">
                                    <div className="flex">
                                        <CiUser size={25} />
                                        <div style={{ borderLeft: '2px solid gray', height: '25px', margin: '0 10px' }}></div>
                                        <p className="font-large">{chat.data}</p>
                                    </div>
                                </div>
                                <hr style={{ width: '100%', border: '1px solid slategrayt' }} />
                            </div>
                        )
                    }
                    else if (chat.type == "calculate") {
                        return (
                            <div key={index} ref={isLastElement ? loadingConsoleRef : null}>
                                <div className="desc-box module">
                                    <MarkdownLatexRenderer content={chat.data} />
                                </div>
                                <hr style={{ width: '100%', border: '1px solid slategrayt' }} />
                            </div>
                        )
                    }
                    else if (chat.type == "visualization") {
                        return (
                            <div key={index} ref={isLastElement ? loadingConsoleRef : null}>
                                <div className="desc-box">
                                    <div className="inner-desc">
                                        <Sheet
                                            onClose={() => setDialogOpen(-1)}
                                            isOpen={index == dialogOpen}
                                            title="Visualization"
                                            children={<Visalization chart={chat.data} />}
                                        />
                                        <button
                                            onClick={() => setDialogOpen(index)}
                                            style={{
                                                backgroundColor: 'lightgray',
                                                color: 'black',
                                                padding: '10px 20px',
                                                border: 'none',
                                                borderRadius: '5px',
                                                cursor: 'pointer',
                                                fontSize: '16px'
                                            }}
                                        >
                                            Open Visualization
                                        </button>
                                        <Visalization chart={chat.data} />
                                    </div>
                                </div>
                                <hr style={{ width: '100%', border: '1px solid slategrayt' }} />
                            </div>
                        )
                    }
                    else if (chat.type == "graph") {
                        console.log(chat.other, "graph")
                        return (
                            <div key={index} ref={isLastElement ? loadingConsoleRef : null}>
                                <div className="desc-box">
                                    <Altair jsonString={chat.data} />
                                </div>
                                <div style={{ color: 'white', padding: '10px 0', display: 'flex', justifyContent: 'center', alignItems: 'center' }} className="desc-box">
                                    <p className="inner-desc">
                                        {chat.other && chat.other[0] || "d"}
                                    </p>
                                </div>
                                <hr style={{ width: '100%', border: '1px solid slategrayt' }} />
                            </div>
                        )
                    }
                })
            }
            <LoadingTool />
        </div>
    )
}


interface MarkdownLatexRendererProps {
    content: string;
}

const MarkdownLatexRenderer: React.FC<MarkdownLatexRendererProps> = ({ content }) => {
    return (
        <div className="inner-desc">
            <ReactMarkdown
                remarkPlugins={[remarkMath, remarkGfm]} // Added remarkGfm for table support
                rehypePlugins={[rehypeKatex]}
                components={{
                    // Handle potential rendering issues
                    p: ({ children }) => <p>{children}</p>,
                    table: ({ children }) => (
                        <table style={{ borderCollapse: "collapse", width: "100%", color: "#e0e0e0" }}>
                            {children}
                        </table>
                    ),
                    th: ({ children }) => (
                        <th
                            style={{
                                border: "1px solid #444",
                                padding: "8px",
                                backgroundColor: "#333",
                                color: "#e0e0e0",
                            }}
                        >
                            {children}
                        </th>
                    ),
                    td: ({ children }) => (
                        <td
                            style={{
                                border: "1px solid #444",
                                padding: "8px",
                                backgroundColor: "#222",
                                color: "#e0e0e0",
                            }}
                        >
                            {children}
                        </td>
                    ),
                }}
            >
                {content}
            </ReactMarkdown>
        </div>
    );
};
